<template lang="pug">
div
    div(
        v-if="$config.runtime.theme.footer.splashBar.items.length > 0"
        class="or-footer-splash-bar bg-gray-light text-black px-3 py-1 lg:py-3 lg:bg-gray-lighter"
    )
        div(class="lg:container flex flex-wrap justify-center items-center xl:justify-between")
            div(
                v-if="$config.runtime.theme.footer.splashBar.title"
                class="hidden mb-5 font-bold text-2xl uppercase text-center leading-none whitespace-nowrap w-full lg:block"
                :class="{ 'xl:text-left xl:mb-0 xl:mr-16 xl:w-auto': !isSimpleMode }"
            ) {{ $config.runtime.theme.footer.splashBar.title }}

            div(class="flex-1 flex flex-wrap justify-center items-center lg:justify-between")
                template(v-for="(item, index) in $config.runtime.theme.footer.splashBar.items")
                    div(
                        class="py-2 lg:py-0"
                        :class="{ 'hidden lg:block': index > 0 }"
                    )
                        SplashBarItem(
                            :icon="item.icon"
                            :text="item.text"
                            :subText="item.subText"
                            :action="item.action"
                        )

    div(class="flex justify-around text-black py-4 lg:pb-4 lg:hidden")
        SplashBarItem(
            v-if="$chat.enabled"
            icon="chat-square-outline"
            text="Live Chat"
            action="chat"
        )

</template>

<script>
import SplashBarItem from './splashBarItem'

export default {
    name: 'SplashBar',
    components: {
        SplashBarItem,
    },
    computed: {
        isSimpleMode() {
            return this.$store.state.isSimpleMode
        },
    },
}
</script>
